<template>
  <div class="header">
    <div v-if="!isMobile">
      <components :is="affiliateHeader" />
    </div>

    <b-container v-if="isMobile">
      <b-row no-gutters>
        <b-col cols="12" class="pd-0">
          <components :is="affiliateMobileHeader" />

          <div class="mobile-sub-header">
            <div
              v-if="currentPage !== 'UserMain' && !$root.isAuthenticated"
              class="login"
              id="login"
              @click="openThairathLogin"
            >
              <IconLogin />
              <span>
                {{ $t('login') }}
              </span>
            </div>
            <div
              v-if="currentPage !== 'UserMain' && $root.isAuthenticated"
              class="login"
              id="userDashboard"
              @click="goToPage('user-dashboard')"
            >
              <b-avatar v-if="userProfileImage" :size="31" :src="userProfileImage"></b-avatar>
              <span style="margin-left:5px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 100px;">
                {{ userName }}
              </span>
            </div>
            <div
              v-if="currentPage !== 'UserMain' && $root.isAuthenticated"
              class="btn-post in-web"
              id="addListing"
              @click="addListing"
            >
              <IconListAdd />
              <span>
                {{ $t('addListing.name') }}
              </span>
            </div>
            <div v-if="currentPage == 'UserMain'" class="btn-post" id="addListing" @click="addListing">
              <IconListAdd />
              <span>
                {{ $t('addListing.name') }}
              </span>
            </div>
            <div
              v-if="currentPage !== 'UserMain' && !$root.isAuthenticated"
              class="sign-up"
              id="signUp"
              @click="userSignup"
            >
              <IconUserPlus />
              <span>
                {{ $t('signup') }}
              </span>
            </div>
            <div v-if="currentPage !== 'UserMain'" class="search" @click="toggleSidebar">
              <MagnifyIcon />
            </div>
            <div>
              <b-sidebar id="search-sidebar" v-model="isToggleSidebar" no-header right backdrop shadow>
                <div class="px-3 py-2">
                  <div class="wrap-input-search">
                    <b-form-input
                      class="input-search"
                      v-model="search"
                      @blur="handleSearch"
                      :placeholder="$t('search.search')"
                    ></b-form-input>
                    <MagnifyIcon class="icon-search" />
                  </div>
                  <div class="text">
                    {{ $t('header.searchHeader.or') }}
                  </div>
                  <b-button class="btn-post" @click="showSidebarAdvanceSearch">
                    <MagnifyIcon />
                    {{ $t('header.searchHeader.search') }}
                  </b-button>
                </div>
              </b-sidebar>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import IconLogin from '@/components/icons/IconLogin/index';
import IconUserPlus from '@/components/icons/IconUserPlus/index';
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import IconListAdd from '@/components/icons/IconListAdd/index';
// import UserIcon from "@/components/icons/IconUser/index";
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
  // name: "header",
  components: {
    IconLogin,
    IconUserPlus,
    MagnifyIcon,
    IconListAdd,
    // UserIcon,
  },
  props: {
    currentPage: {
      type: String,
      default: 'website',
    },
  },
  data() {
    return {
      toggleButton: false,
      isToggleSidebar: false,
      isShowSidebarAdvanceSearch: false,
      search: null,
      userName:
        localStorage.getItem('user_profile') && JSON.parse(localStorage.getItem('user_profile')).display_name
          ? JSON.parse(localStorage.getItem('user_profile')).display_name
          : '',
      userProfileImage: '/images/avatar.png',
    };
  },
  watch: {
    isShowSidebarAdvanceSearch: function(status) {
      if (status) {
        document.body.className = 'body-scroll-hidden';
      } else {
        document.body.className = '';
      }
    },
    isLogin: function(val) {
      if (val) {
        setTimeout(() => {
          this.userName = JSON.parse(localStorage.getItem('user_profile')).display_name;
          this.getAvatarUser();
        }, 500);
      }
    },
  },
  computed: {
    ...mapGetters('UserController', ['isMobile']),
    ...mapGetters('SiteConfigController', ['projectConfig', 'headerLogoSvg']),
    ...mapGetters('CategoryController', ['textSearch']),
    affiliateHeader() {
      console.log('projectConfig', this.projectConfig);
      const template = this.projectConfig ? this.projectConfig.header_html : '';
      return {
        template,
      };
    },
    affiliateMobileHeader() {
      const template = this.projectConfig ? this.projectConfig.header_mobile_html : '';
      return {
        template,
      };
    },
  },

  mounted() {
    this.getAvatarUser();
  },
  created() {
    var text_search = this.textSearch;
    this.search = text_search;
    if (this.$root.isAuthenticated) {
      this.$store.dispatch('UserController/USER_PROFILE');
    }
    this.createBrowserID();
  },
  methods: {
    ...mapActions('AdsController', ['GET_BROWSER_ID']),
    ...mapMutations('AdsController', ['SET_BROWSER_ID']),
    ...mapActions('CategoryController', ['GET_TEXT_SEARCH', 'GET_ID_ATTR', 'GET_IS_COUNT_MOBILE']),

    handleSearch() {
      this.GET_TEXT_SEARCH(this.search);
    },
    getAvatarUser() {
      if (localStorage && localStorage.getItem('user_profile')) {
        let avatar_url = JSON.parse(localStorage.getItem('user_profile')).profile_image;
        if (avatar_url) {
          this.userProfileImage = avatar_url;
        } else {
          this.userProfileImage = '/images/avatar.png';
        }
      }
    },
    toggleButtonMenu() {
      this.toggleButton = !this.toggleButton;
    },
    openThairathLogin() {
      this.$root.signIn();
    },
    userLogout() {
      this.$root.signOut();
    },
    goToPage(page) {
      switch (page) {
        case 'add-listing':
          this.$router.push(this.$i18nRoute({ name: 'AddListing' }));
          break;
        case 'user-dashboard':
          this.$router.push(this.$i18nRoute({ name: 'user-dashboard' }));
          break;
        default:
          break;
      }
    },
    toggleSidebar() {
      console.log('this.$router.currentRoute.path', this.$router.currentRoute.name == 'SearchGrid');
      if (this.$router.currentRoute.name != 'SearchGrid') {
        this.$router.push(this.$i18nRoute({ name: 'search' }));
      } else {
        this.$router.push(this.$i18nRoute({ name: '' }));
      }
      // if (
      // 	this.$router.currentRoute.path ==
      // 	this.$i18nRoute({ name: 'advance-search' })
      // ) {
      // 	this.$router.go(-1);
      // } else {
      // 	this.isToggleSidebar = !this.isToggleSidebar;
      // }
    },
    showSidebarAdvanceSearch() {
      this.GET_IS_COUNT_MOBILE();
      this.$router.push(this.$i18nRoute({ name: 'SearchGrid' }));
    },
    addListing() {
      if (!this.$root.isAuthenticated) {
        this.$root.signIn();
      } else {
        this.$router.push(this.$i18nRoute({ name: 'add-listing' }));
        if (this.$router.history.current == 'EditListing') {
          setTimeout(() => {
            this.$router.go();
          }, 100);
        }
      }
    },
    userSignup() {
      this.$root.signIn();
    },
    uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },

    createBrowserID() {
      let a = this.uuidv4();
      let hide_popup = localStorage && localStorage.getItem('browser_id') ? localStorage.getItem('browser_id') : null;
      if (!hide_popup) {
        this.GET_BROWSER_ID(a);
        localStorage.setItem('browser_id', a);
      } else {
        this.GET_BROWSER_ID(localStorage.getItem('browser_id'));
      }
    },
  },
};
</script>
<style lang="scss">
@import 'style';
</style>
